const createProductStoreService = ({
  store,
  apiProducts,
  getProductByArticle,
  getCheckboxState = () => ({}),
}) => {
  const loadProductsToStore = async () => {
    await apiProducts().then(data => {
      const payload = Array.isArray(data) ? { carts: data } : data || {}
      const metadata = payload.metadata ?? {}
      const carts = payload.carts ?? payload.data ?? []
      const contractors = Array.isArray(metadata.contractors)
        ? metadata.contractors
        : (Array.isArray(payload.contractors) ? payload.contractors : [])
      store.deliveriesByCart = payload.deliveries && typeof payload.deliveries === 'object'
        ? payload.deliveries
        : {}
      const checkboxState = getCheckboxState()
      carts.forEach( ( product, k ) => {
        const article = product.product && product.product.productCode
          ? String(product.product.productCode)
          : ''
        if (article && Object.prototype.hasOwnProperty.call(checkboxState, article)) {
          product.isActive = checkboxState[article] === true
        }
        product.product.imageId = metadata.image_ids[ k ];
        store.productCollection.add(product)
      })

      contractors.forEach(contractor => {
        if (contractor.contractorId === metadata.currentContractorId) {
          store.contractor = contractor
        }
        store.contractorCollection.add(contractor)
      })

      if (!store.contractor && payload.currentContractor) {
        store.contractor = payload.currentContractor
        store.contractorCollection.add(payload.currentContractor)
      } else if (!store.contractor && contractors.length) {
        store.contractor = contractors[0]
      }
    })
  }

  const addProductToStore = article => {
    const articleProduct = getProductByArticle(article)

    // Цена может прийти undefined/NaN/нечислом (напр. из window.productItems
    // живого поиска, где ключа price нет) — приводим к числу. price=0 в сторе
    // трактуется как «товар недоступен» и уводит позицию в OOS-блок:
    // осознанная деградация вместо NaN («не число ₽») в виджете/странице/итого.
    const rawPrice = Number(articleProduct && articleProduct.price)

    store.productCollection.add({
      product : articleProduct,
      price : Number.isFinite(rawPrice) ? rawPrice : 0
    })

    // Товар добавлен локально (клик «+» на каталоге/в виджете): серверного
    // entry в deliveriesByCart для него ещё нет — он появится только после
    // перезагрузки, когда позиция придёт из серверной корзины. Без entry
    // getDeliveries() и getOutOfStockProducts() считают товар out-of-stock и
    // исключают его из доставок, из-за чего количество застревает на одном
    // шаге (getNewProductCartAmount не находит позицию и каждый раз отдаёт
    // step). Создаём delivery-заглушку с реальным складским потолком, чтобы
    // товар сразу считался «в наличии» во всех местах детекции OOS.
    store.deliveriesByCart = store.deliveriesByCart || {}
    if (articleProduct && articleProduct.id && !store.deliveriesByCart[articleProduct.id]) {
      const stock = Array.isArray(articleProduct.warehouseStock) ? articleProduct.warehouseStock[0] : null
      const maxAmount = stock && typeof stock.amount === 'number' ? stock.amount : 0
      store.deliveriesByCart[articleProduct.id] = { slices: [], totalAmount: maxAmount }
    }
  }

  return {
    loadProductsToStore,
    addProductToStore,
  }
}

export { createProductStoreService }
export default createProductStoreService
